<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card">
                <div class="card-body">
                    <pagination-table :data="orderStepsArray || []" :propsToSearch="['id']" searchPlaceholder="Search id" title="Order Steps">
                        <template slot="table" slot-scope="scope">
                            <order-steps-table :data="scope.data || []"></order-steps-table>
                        </template>
                    </pagination-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { firebaseObjectToArray } from '@/utils'
import PaginationTable from 'Shared/Tables/PaginationTable'
import OrderStepsTable from 'Shared/Tables/OrderStepsTable'
import { ORDERS } from 'db'
import { ORDER_ACTIONS } from '@/utils/constants'
export default {
    components: {
        PaginationTable,
        OrderStepsTable
    },
    props: {
        orderSteps: {
            type: [Object, Boolean],
            required: true
        }
    },
    data() {
        return {
            ORDER_ACTIONS,
            ORDERS
        }
    },
    computed: {
        orderStepsArray() {
            return firebaseObjectToArray(this.orderSteps)
        }
    }
}
</script>
